/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1781
 */

"use strict"

var /* [auto-meaningful-name] */require_401_$$_1754_401$forEach = require(/* 401 */"../1754/401").forEach
var o = require(/* 717 */"../1608/717")("forEach")
module.exports = o ? [].forEach : function (e) {
  return require_401_$$_1754_401$forEach(this, e, arguments.length > 1 ? arguments[1] : undefined)
}
